import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DownloadIcon from '@material-ui/icons/GetApp';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import FileSaver from 'file-saver';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { ListItemIcon } from '@material-ui/core';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Typography
			component="div"
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box>{children}</Box>}
		</Typography>
	);
}

class SourceFiles extends React.Component {

	constructor(props) {
		super(props);
		this.state = { 'value': 0, 'copyInfo': { 'open': false, 'fileName': null } };
		this.testRef = React.createRef();
	}

	copyToClipboard = (textToCopy) => {
		const el = document.createElement('textarea');
		el.value = textToCopy;
		el.setAttribute('readonly', '');
		el.style.position = 'absolute';
		el.style.left = '-9999px';
		document.body.appendChild(el);
		const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
		if (selected) {
			document.getSelection().removeAllRanges();
			document.getSelection().addRange(selected);
		}
	};

	openCopyInfo = (sourceFile) => {
		this.setState({ 'value': this.state.value, 'copyInfo': { 'open': true, 'fileName': sourceFile.name } });
	}

	closeCopyInfo = () => {
		this.setState({ 'value': this.state.value, 'copyInfo': { 'open': false, 'fileName': this.state.copyInfo.fileName } });
	}

	handleCopy = (sourceFile) => {
		this.copyToClipboard(sourceFile.source);
		this.openCopyInfo(sourceFile);
	}

	handleDownload = (sourceFile) => {
		var blob = new Blob([sourceFile.source], { type: "text/plain;charset=utf-8" });
		FileSaver.saveAs(blob, sourceFile.name);
	}

	handleChange = (event, newValue) => {
		this.setState({ 'value': newValue });
		if (this.props.onSourceFileChange) {
			this.props.onSourceFileChange(this.props.sourceFiles[newValue]);
		}
	}

	handleClose = (event, index, sourceFile) => {
		if (index <= this.state.value && this.state.value > 0) {
			this.setState({ 'value': this.state.value - 1 });
		}
		this.props.closeAction(sourceFile);
		event.stopPropagation();
	}

	getLineProps = (lineNumber, sourceFile) => {
		const errors = this.props.errors || [];
		const lineStart = sourceFile.source.split('\n').slice(0, lineNumber - 1).join('\n').length;
		const lineEnd = lineStart + sourceFile.source.split('\n')[lineNumber - 1].length;

		const lineErrors = errors ? errors.filter(error =>
			error.codeLocation[0].path.replace(/\\/g, '/') === sourceFile.id &&
			(error.lineNumber ? error.lineNumber.includes(lineNumber) : error.codeLocation[0].startChar >= lineStart &&
			error.codeLocation[0].startChar < lineEnd)
		) : [];
		
		if (lineErrors.length > 0) {
			return {
				style: { backgroundColor: 'rgba(255, 0, 0, 0.2)' },
				title: lineErrors.map(error => error.nameRule).join('\n')
			};
		}
		return {};
	}

	render() {
		if (this.props.sourceFiles.length > 0) {
			const selectedFileIndex = this.props.selectedFileIndex;
			const currentSourceFile = this.props.sourceFiles[selectedFileIndex];
			const currentFileErrors = this.props.errors ? this.props.errors
				.filter(error => error.codeLocation[0].path.replace(/\\/g, '/') === currentSourceFile.id)
				.sort((a, b) => a.codeLocation[0].startChar - b.codeLocation[0].startChar) : [];

			return (
				<div>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Tabs
								indicatorColor="primary"
								textColor="primary"
								variant="scrollable"
								scrollButtons="auto"
								value={selectedFileIndex} 
								onChange={this.handleChange}>
								{
									this.props.sourceFiles.map(
										(sourceFile, index) =>
										(<Tab key={sourceFile.id} label={
											<div className={this.props.style.smallText} style={{ 'textTransform': 'none' }}>
												{sourceFile.name}
												<IconButton className={this.props.style.iconButton} component="span" onClick={(event) => this.handleClose(event, index, sourceFile)}>
													<Close className={this.props.style.smallText} />
												</IconButton>
											</div>} />
										)
									)
								}
							</Tabs>
						</Grid>
					</Grid>
					{
						this.props.sourceFiles.map(
							(sourceFile, index) =>
							(
								<TabPanel key={sourceFile.id} value={selectedFileIndex} index={index} style={{ overflow: 'auto' }}>
									<div style={{ 'position': 'relative' }}>
										<div style={{ 'position': 'absolute', 'top': '5px', 'right': '5px' }}>
											<Tooltip title="Descargar" aria-label="download">
												<Button onClick={() => this.handleDownload(sourceFile)} color='inherit' component="span" >
													<DownloadIcon className={this.props.style.mediumText} />
												</Button>
											</Tooltip>
											<Tooltip title="Copiar" aria-label="copy">
												<Button onClick={() => this.handleCopy(sourceFile)} color='inherit' component="span" >
													<FileCopyIcon className={this.props.style.mediumText} />
												</Button>
											</Tooltip>
										</div>
										<SyntaxHighlighter
											className={this.props.style.sourceCode}
											language={this.props.language}
											style={docco}
											wrapLines={true}
											showLineNumbers={true}
											lineProps={(lineNumber) => this.getLineProps(lineNumber, sourceFile)}
										>
											{sourceFile.source.replace(/\t/g, "   ")}
										</SyntaxHighlighter>
									</div>
								</TabPanel>
							)
						)}
					<Grid>
						<List>
							{currentFileErrors.map((error, index) => {
								const lineNumber = error.lineNumber ? error.lineNumber.toString() : currentSourceFile.source
									.substring(0, error.codeLocation[0].startChar)
									.split('\n').length;

								return (
									<ListItem
										key={index}
										style={{
											padding: '2px',
											backgroundColor: '#FFF8E1', 
											borderRadius: '8px',
											marginBottom: '12px',
											boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
										}}
									>
										<ListItemIcon>
											<Typography style={{ marginLeft: '10px', fontSize: '24px' }}>⚠️</Typography>
										</ListItemIcon>
										<ListItemText
											primary={
												<Typography
													variant="subtitle1"
													style={{
														fontWeight: 'bold',
														fontSize: '16px',
														color: '#424242',
													}}
												>
													Línea {lineNumber}: {error.nameRule}
												</Typography>
											}
											secondary={
												<Typography
													variant="body2"
													style={{
														fontSize: '14px',
														color: '#616161',
														lineHeight: '1.5',
													}}
												>
													{error.description}
												</Typography>
											}
										/>
									</ListItem>
								);
							})}
						</List>
					</Grid>
					<Snackbar open={this.state.copyInfo.open} autoHideDuration={1500} onClose={this.closeCopyInfo}>
						<Alert elevation={6} variant="filled" severity="info">
							{this.state.copyInfo.fileName} copiado al portapapeles!
						</Alert>
					</Snackbar>
				</div>
			)
		} else {
			return (<div> No hay archivos abiertos </div>);
		}
	}

}

export default SourceFiles;
